import { useMemo } from 'react';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorScope,
  AllCollectorsQuery,
  useAllCollectorsQuery,
  Exact,
  Maybe,
  CollectorInput
} from 'graphql/types';
import { useMeContext } from 'modules/me';

export const useAllCollectors = (): {
  data: AllCollectorsQuery | undefined;
  loading: boolean;
  refetch: (
    variables?:
      | any
      | Partial<
          Exact<{
            input?: Maybe<CollectorInput>;
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<AllCollectorsQuery>>;
} => {
  const me = useMeContext();
  const isAdmin = useMemo(() => {
    return me?.permissions.hasCompanyCollectorInstallAccess ? true : false;
  }, [me]);
  const { loading, data, refetch } = useAllCollectorsQuery({
    variables: {
      input: { scope: isAdmin ? CollectorScope.All : CollectorScope.User }
    }
  });

  return useMemo(
    () => ({
      loading,
      data,
      refetch
    }),
    [data, loading, refetch]
  );
};
